import styled from 'styled-components';

// language=SCSS prefix=*{ suffix=}
export const LayoutStyled = styled.div`
    display: flex;
    min-height: 100vh;
`;
